import { STORAGE } from "../storage";
import { hideToast } from "../toastMessage";
import { dispatchAction } from "../state/dispatchAction";
import { setConfig, setLoading, setCurrentState, setConnectionStatus, clearConnectionLogs } from "../../reducers/configSlice";
import { apiGetDeviceConfig } from "../../api/actions";
import { getState } from "../state/getState";
import { deviceLeds } from "../deviceLeds";
import { CONFIG_STATUS_PENDING, SOCKET_CONNECTED, STATE_HOME, STATE_WAITING } from "../../constants/default";
import { EventBus } from "../EventBus";

/**
 * Simple Configuration Service for Soketi
 * Just fetches config and handles response - no internal events
 */

export const fetchDeviceConfig = async () => {
    try {
        const result = await apiGetDeviceConfig();

        if (result.error) {
            console.error('Error fetching device config:', result.error);
            return false;
        }

        const configResponse = result.response;
        if (configResponse) {
            await handleConfigResponse(configResponse);
            return true;
        }

        return false;
    } catch (error) {
        console.error('Error fetching device config:', error);
        return false;
    }
};

/**
 * Handle config response the same way as Socket.IO
 * This replicates the logic from handleConfig.js for Soketi
 */
export const handleConfigResponse = async (configResponse) => {
    hideToast();

    // Check if config is pending (same as Socket.IO)
    if (configResponse.status === CONFIG_STATUS_PENDING || !configResponse?.config?.space_id) {
        dispatchAction(setLoading(false));
        dispatchAction(setCurrentState(STATE_WAITING));
        return;
    }

    // Extract config from response (API returns same structure as Socket.IO)
    const config = {...configResponse.config};

    // Store device UUID if present in config response (for token refresh)
    if (configResponse.uuid) {
        await STORAGE.set('deviceUuid', configResponse.uuid);
    }

    // Handle prodvx token storage (same as Socket.IO)
    if (config?.light_driver?.prodvx_token) {
        await STORAGE.set('prodvx_token', config.light_driver.prodvx_token);
    }

    const prodvxtoken = await STORAGE.get('prodvx_token');

    // Update Redux store with config (same as Socket.IO)
    dispatchAction(setConfig(config));

    // Emit config updated event for RASP monitoring
    EventBus.emit('config_updated', {
        config,
        timestamp: Date.now()
    });

    // Handle device LEDs (same as Socket.IO)
    deviceLeds('off', config?.light_driver, prodvxtoken);

    if (getState('authenticated')) {
        dispatchAction(setLoading(false));
        dispatchAction(setCurrentState(STATE_HOME));
    }

    dispatchAction(setConnectionStatus(SOCKET_CONNECTED));
    dispatchAction(clearConnectionLogs());
};

export default {
    fetchDeviceConfig,
    handleConfigResponse
};
